import React from 'react';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
    return (
        <div className="bg-white text-black min-h-screen p-8 mt-12">
            <SEO
                title="Privacy Policy - The Hive Workspaces"
                description="Read The Hive Workspaces privacy policy. Learn how we collect, use, and protect your personal information."
                canonical="/privacy-policy"
            />
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-center mb-8 text-gray-800">
                    PRIVACY POLICY
                </h1>

                <div className="space-y-8">
                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">1. Introduction</h2>
                        <p className="text-gray-800 leading-relaxed">
                            At The Hive, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose and safeguard your information when you visit our website or use our services.
                        </p>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">2. Information Collection</h2>
                        <p className="text-gray-800 leading-relaxed">
                            We collect information that you provide directly to us, such as when you create an account, make a booking, or contact our support team. This may include your name, email address, phone numberand payment information.
                        </p>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">3. Use of Information</h2>
                        <p className="text-gray-800 leading-relaxed">
                            We use the information we collect to:
                        </p>
                        <ul className="list-disc ml-6 mt-4 space-y-2 text-gray-800">
                            <li>Provide, maintain and improve our services.</li>
                            <li>Process transactions and send related information.</li>
                            <li>Send you technical notices, updates and support messages.</li>
                            <li>Respond to your comments and questions.</li>
                        </ul>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">4. Sharing of Information</h2>
                        <p className="text-gray-800 leading-relaxed">
                            We do not share your personal information with third parties except as described in this policy or with your consent. We may share information with vendors and service providers who perform services for us.
                        </p>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">5. Security</h2>
                        <p className="text-gray-800 leading-relaxed">
                            We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.
                        </p>
                    </section>

                    <section className="pb-8">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">6. Contact Us</h2>
                        <p className="text-gray-800 leading-relaxed">
                            If you have any questions about this Privacy Policy, please contact us at:
                            <br />
                            Email: hello@hiveworkspaces.com
                            <br />
                            Phone: +91 7022274000
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
